import type { FC } from 'react'
import { SvgIconProps } from '@mui/material'

import { useFestiveVariants } from '@dhl/utils'

import { AnnouncedDefault } from './AnnouncedDefault.js'
import { AnnouncedChristmas } from './AnnouncedChristmas.js'
import { AnnouncedEaster } from './AnnouncedEaster.js'

export const Announced: FC<SvgIconProps> = (props) => {
  const Component = useFestiveVariants({
    christmas: AnnouncedChristmas,
    default: AnnouncedDefault,
    easter: AnnouncedEaster,
  })

  return <Component {...props} />
}
